type BrandStyle = {
  label: React.ReactNode;
  className: string;
};

const brands: BrandStyle[] = [
  { label: "BOSS", className: "font-black text-2xl tracking-tight" },
  { label: <em className="not-italic italic">DIESEL</em>, className: "font-bold italic text-xl tracking-wide" },
  { label: "HERNO", className: "font-light text-lg tracking-[0.35em]" },
  { label: "ELEVENTY", className: "font-medium text-sm tracking-[0.4em]" },
  { label: "DONDUP", className: "font-extrabold text-xl tracking-tight" },
  {
    label: (
      <>
        DSQUARED<sup className="text-xs">2</sup>
      </>
    ),
    className: "font-bold text-xl tracking-tight",
  },
  { label: "TOMMY HILFIGER", className: "font-bold text-base tracking-[0.18em]" },
];

export function Marquee() {
  // Duplico la sequenza per loop seamless
  const track = [...brands, ...brands, ...brands, ...brands];

  return (
    <div className="bg-stone-900 py-5 overflow-hidden border-y border-stone-800">
      <style>{`
        @keyframes marquee-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          align-items: center;
          width: max-content;
          animation: marquee-scroll 38s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>
      <div className="marquee-track">
        {track.map((b, i) => (
          <span
            key={i}
            className={`text-white whitespace-nowrap px-10 sm:px-14 opacity-80 hover:opacity-100 transition-opacity ${b.className}`}
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {b.label}
          </span>
        ))}
      </div>
    </div>
  );
}
